import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SuggestAChange } from '../../shared/models/suggest-a-change.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class SuggestAChangeService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * sends suggested change to api to be emailed
   * @return {Promise<any>}
   * @param airportId
   * @param airportAbbrev
   * @param changeDetails
   */
  postChangeRequestAirport(airportId: number, airportAbbrev: string, changeDetails: SuggestAChange): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportId}/${airportAbbrev}/changerequest/`;
    try {
      const BODY = this._getSuggestAChangeJSON(changeDetails);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  postChangeRequestBusiness(businessId: number, changeDetails: SuggestAChange): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessId}/changerequest/`;
    try {
      const BODY = this._getSuggestAChangeJSON(changeDetails);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  _getSuggestAChangeJSON(change: SuggestAChange): any {
    return {
      name: change.name,
      email: change.email,
      details: change.details,
      recId: change.recId
    };
  }
}
